@if (previewAsset() && !noAsset()) {
  <div class="cover-container-asset" [style.color]="theme().cover.overlay_color || 'transparent'" #cover>
    @let asset = previewAsset();
    @if ((asset | canDisplayAsset) && asset.type !== 'audio') {
      <img
        [src]="
          asset.version_data
            | assetVersionUrl
              : asset
              : asset.version_data.status
              : cover.clientWidth
              : cover.clientHeight
              : !!gallery().watermark
        "
        alt=""
      />
    }
  </div>
} @else if (gallery().cover.uuid && !noAsset()) {
  <div class="cover-container-asset" [style.color]="theme().cover.overlay_color || 'transparent'" #cover>
    @if (
      !gallery().cover.video_origin && gallery().cover?.uuid
        | galleryCoverUrl
          : gallery().cover.width
          : gallery().cover.height
          : cover.clientWidth
          : cover.clientHeight
          : gallery().cover.ext;
      as coverSrc
    ) {
      <img [src]="coverSrc" alt="" [style.object-position]="gallery().cover.position" />
    }
    @if (gallery().cover.video_origin) {
      <app-video-viewer
        [videoData]="gallery().cover | coverToVideoData: gallery().cover.video_origin"
        [uuid]="gallery().cover.video_origin | videoOrigin: 'uuid'"
        [origin]="gallery().cover.video_origin | videoOrigin: 'origin'"
        [poster]="
          gallery().cover?.uuid
            | galleryCoverUrl
              : gallery().cover.width
              : gallery().cover.height
              : cover.clientWidth
              : cover.clientHeight
              : gallery().cover.ext
        "
        [active]="true"
        [showUi]="false"
        [autoplay]="true"
        [muted]="true"
        [loop]="true"
        [cover]="true"
        [coverPosition]="gallery().cover.position"
        [targetWidth]="cover.clientWidth"
      ></app-video-viewer>
    }
  </div>
} @else if (!allowEmptyStyle()) {
  <div class="cover-container-asset transparent" #cover>
    <div class="placeholder"></div>
  </div>
}
